import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const sid = localStorage.getItem("stuff_sid");
  if (sid) config.headers["X-Stuff-Sid"] = sid;
  return config;
});

export function imageUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return path;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessaie.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Normalise un numéro FR pour wa.me / liens: 06... -> 336..., garde l'indicatif si présent
export function waNumber(raw) {
  let n = (raw || "").replace(/[^0-9]/g, "");
  if (!n) return "";
  if (n.startsWith("00")) n = n.slice(2);
  else if (n.startsWith("0")) n = "33" + n.slice(1);
  return n;
}

export function whatsappLink(phone, text) {
  const n = waNumber(phone);
  if (!n) return "";
  return `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export function telegramLink(handle, text) {
  const h = (handle || "").replace("@", "").replace(/https?:\/\/t\.me\//, "").trim();
  if (!h) return "";
  return `https://t.me/${h}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export function snapchatLink(handle) {
  const h = (handle || "").replace("@", "").replace(/https?:\/\/(www\.)?snapchat\.com\/add\//i, "").trim();
  if (!h) return "";
  return `https://www.snapchat.com/add/${encodeURIComponent(h)}`;
}


export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 15000);
}
